import React from 'react';
import './styles.scss';

const HappyHacking = props => {
  return (
    <div className="tc">
      <p data-cy="footer" className="App-intro">
        <code>Happy hacking!</code>
      </p>
    </div>
  );
};

export default HappyHacking;
